import API from '../utils/API';
import { makeActionCreator, makeGenericActionCreatorTypeSafe } from '../utils/reduxUtils';
import { PAGINATION_PAGE_SIZE } from '../utils/constants';
import { grpcUnaryCall } from "../utils/grpc/grpcUtils";
import { GetTrialLimitRequest, UpdateTrialLimitRequest } from '../utils/grpc/generated/Billsby.Protos/core/private/companies/company_pb';
import { CompanyServiceClient } from '../utils/grpc/generated/Billsby.Protos/core/private/companies/CompanyServiceClientPb';
import { ConfigConstants } from '../utils/config';
import { GetTrialBalanceRequest } from '../utils/grpc/generated/Billsby.Protos/revenues/private/company/company_pb';
import { CompanyServiceClient as RevenueCompanyServiceClient } from '../utils/grpc/generated/Billsby.Protos/revenues/private/company/CompanyServiceClientPb';
import { GetTrialLimitsRequest, UpdateStandardTrialLimitRequest, CreateAlternateTrialLimitRequest } from '../utils/grpc/generated/Billsby.Protos/core/private/triallimits/triallimits_pb';
import { TrialLimitsServiceClient } from '../utils/grpc/generated/Billsby.Protos/core/private/triallimits/TriallimitsServiceClientPb';
import { IFreeTrialReducerState } from '../reducers/freeTrialsReducer';
import { multiplyNumberBy100 } from '../utils/commonUtils';


export const RESET_FREE_TRIALS = 'RESET_FREE_TRIALS';
export const resetFreeTrials = makeActionCreator(RESET_FREE_TRIALS, 'payload');

export const SET_FREE_TRIAL_LIMIT_FIELDS = "SET_FREE_TRIAL_LIMIT_FIELDS";
export const setFreeTrialLimitFields = makeGenericActionCreatorTypeSafe<IFreeTrialReducerState>(SET_FREE_TRIAL_LIMIT_FIELDS);

export const FETCH_FREE_TRIALS_REQUEST = 'FETCH_FREE_TRIALS_REQUEST';
export const FETCH_FREE_TRIALS_SUCCESS = 'FETCH_FREE_TRIALS_SUCCESS';
export const FETCH_FREE_TRIALS_FAILURE = 'FETCH_FREE_TRIALS_FAILURE';

export const UPDATE_FREE_TRIALS_REQUEST = 'UPDATE_FREE_TRIALS_REQUEST';
export const UPDATE_FREE_TRIALS_SUCCESS = 'UPDATE_FREE_TRIALS_SUCCESS';
export const UPDATE_FREE_TRIALS_FAILURE = 'UPDATE_FREE_TRIALS_FAILURE';

export const ADD_ALTERNATE_FREE_TRIALS_REQUEST = 'ADD_ALTERNATE_FREE_TRIALS_REQUEST';
export const ADD_ALTERNATE_FREE_TRIALS_SUCCESS = 'ADD_ALTERNATE_FREE_TRIALS_SUCCESS';
export const ADD_ALTERNATE_FREE_TRIALS_FAILURE = 'ADD_ALTERNATE_FREE_TRIALS_FAILURE';

export const fetchFreeTrials = function () {
  const getTrialLimitsRequest = new GetTrialLimitsRequest();
  const trialLimitsServiceClient = new TrialLimitsServiceClient(ConfigConstants.grpcBaseUrl);

  return ({
    types: [FETCH_FREE_TRIALS_REQUEST, FETCH_FREE_TRIALS_SUCCESS, FETCH_FREE_TRIALS_FAILURE],
    callAPI: () => grpcUnaryCall(getTrialLimitsRequest, trialLimitsServiceClient, trialLimitsServiceClient.getTrialLimits)
  })
}

export const updateStandardFreeTrialLimit = function (limit: number) {
  const updateStandardTrialLimitRequest = new UpdateStandardTrialLimitRequest();
  updateStandardTrialLimitRequest.setLimit(Number(multiplyNumberBy100(limit)) || 0);
  const trialLimitsServiceClient = new TrialLimitsServiceClient(ConfigConstants.grpcBaseUrl);

  return ({
    types: [UPDATE_FREE_TRIALS_REQUEST, UPDATE_FREE_TRIALS_SUCCESS, UPDATE_FREE_TRIALS_FAILURE],
    callAPI: () => grpcUnaryCall(updateStandardTrialLimitRequest, trialLimitsServiceClient, trialLimitsServiceClient.updateStandardTrialLimit)
  })
}

export const addAlternateFreeTrialLimit = function (limit: number) {
  const createAlternateTrialLimitRequest = new CreateAlternateTrialLimitRequest();
  createAlternateTrialLimitRequest.setLimit(Number(multiplyNumberBy100(limit)));
  const trialLimitsServiceClient = new TrialLimitsServiceClient(ConfigConstants.grpcBaseUrl);

  return ({
    types: [ADD_ALTERNATE_FREE_TRIALS_REQUEST, ADD_ALTERNATE_FREE_TRIALS_SUCCESS, ADD_ALTERNATE_FREE_TRIALS_FAILURE],
    callAPI: () => grpcUnaryCall(createAlternateTrialLimitRequest, trialLimitsServiceClient, trialLimitsServiceClient.createAlternateTrialLimit)
  })
}